module.exports = __webpack_public_path__ + "static/media/react.c4eb3d0b.jpg";